import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  isEmptyObject,
  getLocalStorageObject,
  setLocalStorageObject,
  sessionExpireHandle
} from "../../../util/helper";

import {
  getInstruments,
  getExpiries,
  getPrice,
  getOptionChainInstrumentsData,
  saveTicksData,
  getworldtimeapi,
  getHolidays,
  saveStrikeData,
  saveSyntPrice,
  saveSynToken,
  saveMiddleStrike
} from "../../../redux/actions/optionChain";

import { placeOrdersAction, basketAction, getMarginAction } from "../../../redux/actions/brokerAction";

import {
  TableRow,
  Table,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
} from "@material-ui/core";
// material-ui
import { Card } from "react-bootstrap";
import Centrifuge from "centrifuge";
import OptionChainTable from "./OptionChainTable";
import { columns, getColumn } from "./columnConfig";
import { getFullStrikeStocks } from "./stock";
import moment from "moment";
import { Radio, Checkbox, Tooltip, InputNumber, Switch, Modal } from "antd";
import OptionChainTabs from "../dashboard/optionChainTabs";
// style constant
import CustomOption from "../custom";
import { generateUniqueId } from "../../../util/helper";
import LoderCom from "../../common/Loder";
import Item from "antd/es/list/Item";

const exchange = "NSE";

const config = {
  defaultColumnIds: [
    "volCE",
    "oiPChgCE",
    "oiChgCE",
    "oiCE",
    "lpCE",
    "posPE",
    "strike",
    "posPE",
    "lpPE",
    "oiPE",
    "oiChgPE",
    "oiPChgPE",
    "volPE",
  ],
  moreColumnIds: [
    "buildup",
    "trend",
    "orderflow",
    "delta",
    "gamma",
    "theta",
    "vega",
    "bid",
    "ask",
    "atp",
    "pChg",
    "chg",
    "ivChg",
    "iv",
    "pcr",
    "ltpChgOpen",
    "ltpChgPOpen",
  ],
  positionedArray: [
    "vegaCE",
    "gammaCE",
    "thetaCE",
    "deltaCE",
    "ivChgCE",
    "ivCE",
    "trendCE",
    "buildupCE",
    "orderflowCE",
    "volCE",
    "pcrCE",
    "oiPChgCE",
    "oiChgCE",
    "oiCE",
    "ltpChgPOpenCE",
    "ltpChgOpenCE",
    "pChgCE",
    "chgCE",
    "atpCE",
    "lpCE",
    "askCE",
    "bidCE",
    "strike",
    "bidPE",
    "askPE",
    "lpPE",
    "atpPE",
    "chgPE",
    "pChgPE",
    "ltpChgOpenPE",
    "ltpChgPOpenPE",
    "oiPE",
    "oiChgPE",
    "oiPChgPE",
    "pcrPE",
    "volPE",
    "orderflowPE",
    "buildupPE",
    "trendPE",
    "ivPE",
    "ivChgPE",
    "deltaPE",
    "thetaPE",
    "gammaPE",
    "vegaPE",
    "SbCE",
    "SbPE",
    "SbCEOI",
    "SbPEOI",
  ],
  combinedItems: {
    trend: { display: "Trend", arr: ["trend"] },
    buildup: { display: "Build Up", arr: ["buildup"] },
    orderFlow: { display: "OrderFlow", arr: ["orderflow"] },
    greeks: { display: "Greeks", arr: ["delta", "gamma", "theta", "vega"] },
    bidAsk: { display: "Bid/Ask", arr: ["bid", "ask"] },
    ltpChgClose: { display: "LTP chg (close)", arr: ["pChg", "chg"] },
    ltpChgOpen: {
      display: "LTP chg (open)",
      arr: ["ltpChgOpen", "ltpChgPOpen"],
    },
    iv: { display: "IV", arr: ["ivChg", "iv"] },
    pcr: { display: "PCR", arr: ["pcr"] },
    atp: { display: "ATP", arr: ["atp"] },
  },
  //moreColumnIdsArray: ["trend", "buildup", "orderFlow", "greeks", "bidAsk", "ltpChgClose", "ltpChgOpen", "iv", "pcr"]
  moreColumnIdsArray: [
    "trend",
    "buildup",
    "orderFlow",
    "bidAsk",
    "ltpChgClose",
    "ltpChgOpen",
    "pcr",
    "atp",
    "iv",
    "greeks",
  ],
};

let localStorageObj = getLocalStorageObject("global") || {
  strikeValue: 10,
};

const OptionActionTable = ({
  inputValues,
  //getlotSize,
  selectInstrument,
  selectExpiry,
  globleOptionChainType,
  width,
  height,
  type,
  info,
  getATMprice,
  buySellClick,
  setisQT,
  isQT,
  chartClick,
  isRefresh,
  hedgeVal,
  sethedgeVal,
  hedge,
  sethedge,
  atmVal,
  setatmVal,
  isDeltaIV,
  setIsDeltaIV,
  setColumns,
  DropDonwcolumns,
  rowHover,
  setisSellFirst,
  isSellFirst
}) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const defaultStrike = 10;
  const user = useSelector((state) => state.user);
  const optionChainInstrument = useSelector((state) => state.optionChaininstruments.data);
  const basket = useSelector((state) => state.basket.data);
  const spotPrice = useSelector((state) => state?.optionChaininstruments?.spotPrice);
  const futPrice = useSelector((state) => state?.optionChaininstruments?.futPrice);
  const synFutPrice = useSelector((state) => state?.optionChaininstruments?.synFut);
  const postionList = useSelector((state) => state?.orders);

  const tickData = useSelector((state) => state?.optionChaininstruments?.tickData);

  // input selection states
  // const [selectStrikes, setSelectStrikes] = useState(
  //   getLocalStorageObject("option-chain-table")?.strikeValue || defaultStrike
  // );

  const [lotSizeEnabled, setLotSizeEnabled] = useState(
    getLocalStorageObject("global")?.lotSize || false,
  );
  const [lotSizesByToken, setLotSizesByToken] = useState({});
  const [summary, setSummary] = useState(false);
  const [strikeArray, setStrikeArray] = useState([]);

  //columns
  const [columnIds, setColumnIds] = useState(config.defaultColumnIds);
  const [moreColumnStatus, setMoreColumnStatus] = useState(
    getLocalStorageObject("global")?.moreColumnStatus ||
    config.moreColumnIdsArray.map((id) => ({
      id: id,
      status: id == "trend" || id == "buildup" ? true : false,
    })),
  );

  // price states
  const [price, setPrice] = useState();
  const [middleStrike, setMiddleStrike] = useState();
  const [symbolsToStrike, setSymbolsToStrike] = useState({});
  const [optionChainInstrumentsData, setOptionChainInstrumentsData] = useState(
    [],
  );
  const [tableData, setTableData] = useState({});

  //socket data
  const [source, setSource] = useState(() => { });
  // const [realTimeChartData, setRealTimeChartData] = useState({});

  const stockDataRef = useRef({});
  const timeoutRef = useRef();
  const strikeVal = useRef("10");
  const [prevData, setPrevData] = useState({});
  const [updateScroll, setUpdateScroll] = useState(true);
  const [spotToken, setSpotToken] = useState();
  const [futToken, setFutToken] = useState();
  const [oicepeData, setOicepeData] = useState([]);
  const [OIChg, setOIChg] = useState("OI");
  const [optType, setOptType] = useState("opt");
  const [exchangeToken, setexchangeToken] = useState('');
  const [selectStrikes, setSelectStrikes] = useState(
    getLocalStorageObject("global")?.strikeValue || defaultStrike,
  );
  const [isStraddle, setStraddle] = useState(true);
  const [isLoder, setisLoder] = useState(true);
  const [defCol, setdefCol] = useState([]);
  const [isPosition, setisPosition] = useState(true);
  const [isSynFut, setisSynFut] = useState(getLocalStorageObject("global")?.isSynFut || false);

  useEffect(() => {
    if (DropDonwcolumns && DropDonwcolumns.length > 0) {
      const filter = DropDonwcolumns.filter((item) => item.enableColumn).map((id) => (id.accessorKey));
      if (isStraddle) {
        let cols = [...filter, 'straddlePrice'];
        if (isSynFut) {
          cols.push('synFut');
        }
        setdefCol(cols);
      } else {
        setdefCol(isSynFut ? [...filter, 'synFut'] : filter)
      }
    }
  }, [DropDonwcolumns, isStraddle, isSynFut]);

  // connecting to socket data
  useEffect(() => {
    const centrifuge = new Centrifuge(
      process.env.REACT_APP_API_FEED
    );
    centrifuge.on("connect", function (ctx) {
      console.log(
        "Connected with client ID " + ctx.client + " over " + ctx.transport
      );
    });
    centrifuge.on("disconnect", function (ctx) {
      console.log(
        "Disconnected: " +
        ctx.reason +
        (ctx.reconnect
          ? ", will try to reconnect"
          : ", won't try to reconnect")
      );
    });
    centrifuge.connect();
    setSource(centrifuge);
  }, []);

  useEffect(() => {
    if (
      optionChainInstrumentsData &&
      optionChainInstrumentsData.length > 0 &&
      price &&
      tickData &&
      Object.keys(tickData).length > 0
      && spotPrice && futPrice && synFutPrice
    ) {

      var pri = 0;

      if (atmVal === "Spot") {
        pri = spotPrice;
      } else if (atmVal === "Futures") {
        pri = futPrice;
      } else {
        pri = synFutPrice;
      }

      if (!pri) {
        return
      }
      getATMprice(pri)
      const { index, middleStrike } = getMiddleStrike(
        optionChainInstrumentsData,
        pri,
      );
      setMiddleStrike(middleStrike);
      dispatch(saveMiddleStrike(middleStrike))
      const { symbolList, symbolsToStrikePrice, strikeList } = getSymbolList(
        optionChainInstrumentsData,
        index,
        selectStrikes,
      );

      const start = Math.max(index - 1 - selectStrikes * 2, 0);
      const end = Math.min(index + selectStrikes * 2, optionChainInstrumentsData.length);
      const visibleStrikes = new Set();
      for (let i = start; i < end; i++) {
        if (optionChainInstrumentsData[i]) visibleStrikes.add(optionChainInstrumentsData[i].strikePrice);
      }
      setStrikeArray([...visibleStrikes]);

      setSymbolData(tickData, symbolList, symbolsToStrikePrice, strikeList);

    }
  }, [spotPrice, futPrice, tickData, price, synFutPrice, atmVal, isRefresh, optionChainInstrumentsData]);

  const setSymbolData = (data, symbolList, symbolsToStrikePrice, strikeList) => {

    if (data && Object.keys(data).length > 0) {


      let symbolsData = {};
      let previ = {};
      strikeList?.forEach((strike) => {
        if (!isEmptyObject(symbolsToStrikePrice[strike]) && symbolsToStrikePrice[strike].CE && symbolsToStrikePrice[strike].PE) {
          const ceSymbol = symbolsToStrikePrice[strike].CE;
          const peSymbol = symbolsToStrikePrice[strike].PE;
          const prevData = {
            CE: {
              oi: data[ceSymbol]?.prev?.oi,
              lp: data[ceSymbol]?.prev?.p,
              iv: data[ceSymbol]?.prev?.iv,
            },
            PE: {
              oi: data[peSymbol]?.prev?.oi,
              lp: data[peSymbol]?.prev?.p,
              iv: data[peSymbol]?.prev?.iv,
            },
          };


          if (data[ceSymbol] && data[peSymbol]) {
            symbolsData[strike] = getFullStrikeStocks(
              data[ceSymbol],
              data[peSymbol],
              strike,
              prevData,
            );
            if (strike === middleStrike) {
              dispatch(saveSynToken(symbolsData[strike]))
              dispatch(saveSyntPrice((parseFloat(strike) + parseFloat(symbolsData[strike].lpCE)) - parseFloat(symbolsData[strike].lpPE)))
            }
            symbolsData[strike].symbolsToStrikePrice = symbolsToStrikePrice[strike]
            previ = { ...previ, [strike]: prevData };
          }
        }
      });
      var current_high_ceoi = 0;
      var current_high_peoi = 0;
      Object.keys(symbolsData)?.forEach((strike) => {
        if (symbolsData[strike].oiCE > current_high_ceoi) {
          current_high_ceoi = symbolsData[strike].oiCE;
        }
        if (symbolsData[strike].oiPE > current_high_peoi) {
          current_high_peoi = symbolsData[strike].oiPE;
        }
      });
      setOicepeData({
        current_high_ceoi: current_high_ceoi,
        current_high_peoi: current_high_peoi,
        ceoiPer: current_high_ceoi / 100,
        peoiPer: current_high_peoi / 100,
      });
      setPrevData(previ);

      // console.log("previprevi", previ)
      setTableData(symbolsData);
      stockDataRef.current = symbolsData;
      dispatch(saveStrikeData({ ...stockDataRef.current }))

      setSummary(getSummaryDataAtLoading(symbolsData));
      // setisLoder(false);
    }
  }

  useEffect(() => {
    const onPageLoad = () => {
      //setUpdateScroll(false)
      const timer = setTimeout(() => setUpdateScroll(false), 5000);
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, [updateScroll]);

  // session expiring handle


  // execute when instrument chg and stock data changed
  useEffect(() => {
    async function fetchPrice() {
      setPrice();
      const data = await getPrice(
        selectInstrument,
        selectInstrument == "SENSEX" || selectInstrument == "BANKEX"
          ? "BSE"
          : exchange,
        spotToken,
      );
      if (data && data?.sessionExpired) {
        sessionExpireHandle();
      }
      const { lp, exchangeToken, token } = data;
      if (lp && token) {
        setPrice(lp);
        getATMprice(lp)
        setSpotToken(token);
        setexchangeToken(exchangeToken)
      }
    }

    if (selectInstrument) {
      fetchPrice();
      setisLoder(true);
    }
  }, [selectInstrument]);

  // execute when expiry change (when instrument change expiriy definitely change)
  useEffect(() => {
    async function fetchOptionChainInstruments() {
      setisLoder(true)
      const { optData, futToken: futTkn, lotSize, volumeFreeze } = optionChainInstrument;

      //getlotSize(lotSize, volumeFreeze);
      if (optData) {
        setOptionChainInstrumentsData(optData);
        saveLotSizesByTokens(optData);
      }
      if (futTkn) {
        setFutToken(futTkn);
      }
    }


    if (optionChainInstrument && Object.keys(optionChainInstrument).length > 0) {
      fetchOptionChainInstruments();
    }
  }, [optionChainInstrument]);

  useEffect(() => {
    async function fetchSymbolData(
      symbolList,
      symbolsToStrikePrice,
      strikeList,
      middleStrike
    ) {
      const data = await dispatch(saveTicksData(symbolList));

      if (data && data?.sessionExpired) {
        sessionExpireHandle();
      }

      if (data) {


        let symbolsData = {};
        let previ = {};
        strikeList?.forEach((strike) => {
          if (!isEmptyObject(symbolsToStrikePrice[strike]) && symbolsToStrikePrice[strike].CE && symbolsToStrikePrice[strike].PE) {
            const ceSymbol = symbolsToStrikePrice[strike].CE;
            const peSymbol = symbolsToStrikePrice[strike].PE;
            const prevData = {
              CE: {
                oi: data[ceSymbol]?.prev?.oi,
                lp: data[ceSymbol]?.prev?.p,
                iv: data[ceSymbol]?.prev?.iv,
              },
              PE: {
                oi: data[peSymbol]?.prev?.oi,
                lp: data[peSymbol]?.prev?.p,
                iv: data[peSymbol]?.prev?.iv,
              },
            };



            symbolsData[strike] = getFullStrikeStocks(
              data[ceSymbol],
              data[peSymbol],
              strike,
              prevData,
            );
            if (strike === middleStrike) {

              dispatch(saveSynToken(symbolsData[strike]));
              dispatch(saveSyntPrice((parseFloat(strike) + parseFloat(symbolsData[strike].lpCE)) - parseFloat(symbolsData[strike].lpPE)))
            }
            symbolsData[strike].symbolsToStrikePrice = symbolsToStrikePrice[strike]
            previ = { ...previ, [strike]: prevData };
          }
        });
        var current_high_ceoi = 0;
        var current_high_peoi = 0;
        Object.keys(symbolsData)?.forEach((strike) => {
          if (symbolsData[strike].oiCE > current_high_ceoi) {
            current_high_ceoi = symbolsData[strike].oiCE;
          }
          if (symbolsData[strike].oiPE > current_high_peoi) {
            current_high_peoi = symbolsData[strike].oiPE;
          }
        });
        setOicepeData({
          current_high_ceoi: current_high_ceoi,
          current_high_peoi: current_high_peoi,
          ceoiPer: current_high_ceoi / 100,
          peoiPer: current_high_peoi / 100,
        });
        setPrevData(previ);
        setTableData(symbolsData);
        stockDataRef.current = symbolsData;
        dispatch(saveStrikeData({ ...stockDataRef.current }))

        setSummary(getSummaryDataAtLoading(symbolsData));
      }
      setUpdateScroll(true);
      setisLoder(false);
    }

    if (
      optionChainInstrumentsData &&
      optionChainInstrumentsData.length > 0 &&
      price
    ) {

      const { index, middleStrike } = getMiddleStrike(
        optionChainInstrumentsData,
        price,
      );

      setMiddleStrike(middleStrike);
      dispatch(saveMiddleStrike(middleStrike))
      const { symbolList, symbolsToStrikePrice, strikeList } = getSymbolList(
        optionChainInstrumentsData,
        index,
        selectStrikes,
      );

      const start = Math.max(index - 1 - selectStrikes * 2, 0);
      const end = Math.min(index + selectStrikes * 2, optionChainInstrumentsData.length);
      const visibleStrikes = new Set();
      for (let i = start; i < end; i++) {
        if (optionChainInstrumentsData[i]) visibleStrikes.add(optionChainInstrumentsData[i].strikePrice);
      }
      setStrikeArray([...visibleStrikes]);
      
      fetchSymbolData(symbolList, symbolsToStrikePrice, strikeList, middleStrike);

    }
  }, [optionChainInstrumentsData, price, selectStrikes]);

  useEffect(() => {
    if (!isEmptyObject(lotSizesByToken) && !isEmptyObject(symbolsToStrike)) {
      setSummary(getSummaryDataAtLoading(stockDataRef.current));
    }
  }, [lotSizeEnabled]);

  const saveLotSizesByTokens = (optData) => {
    let lotSizes = {};
    optData?.forEach((option) => {
      lotSizes[option.instrumentToken] = option.lotSize;
    });
    setLotSizesByToken(lotSizes);
  };

  // setting summary data
  const getSummaryDataAtLoading = (data) => {
    if (data && Object.keys(data) && Object.keys(data).length > 0) {
      let volCE = 0;
      let oiPChgCE = 0;
      let oiChgCE = 0;
      let oiCE = 0;
      let volPE = 0;
      let oiPChgPE = 0;
      let oiChgPE = 0;
      let oiPE = 0;
      let vegaCE = 0;
      let vegaPE = 0;
      let gammaCE = 0;
      let gammaPE = 0;
      let thetaCE = 0;
      let thetaPE = 0;
      let deltaCE = 0;
      let deltaPE = 0;
      Object.keys(data).forEach((strike, index) => {
        const totalStrikes = parseInt(Object.keys(data).length / 2) + 1;
        const count = index + 1;

        const d = data[strike];
        const lotSizePE =
          (lotSizeEnabled &&
            !isEmptyObject(lotSizesByToken) &&
            !isEmptyObject(symbolsToStrike) &&
            lotSizesByToken[symbolsToStrike[strike].PE]) ||
          1;
        const lotSizeCE =
          (lotSizeEnabled &&
            !isEmptyObject(lotSizesByToken) &&
            !isEmptyObject(symbolsToStrike) &&
            lotSizesByToken[symbolsToStrike[strike].CE]) ||
          1;

        volPE += (d.volPE || 0) / lotSizePE;
        oiPChgPE += d.oiPChgPE || 0;
        oiChgPE += (d.oiChgPE || 0) / lotSizePE;
        oiPE += (d.oiPE || 0) / lotSizePE;

        volCE += (d.volCE || 0) / lotSizeCE;
        oiPChgCE += d.oiPChgCE || 0;
        oiChgCE += (d.oiChgCE || 0) / lotSizePE;
        oiCE += (d.oiCE || 0) / lotSizePE;

        if (totalStrikes < count) {
          vegaCE += (d.vegaCE || 0) / lotSizePE;
          gammaCE += (d.gammaCE || 0) / lotSizePE;
          thetaCE += (d.thetaCE || 0) / lotSizePE;
          deltaCE += (d.deltaCE || 0) / lotSizePE;
        }

        if (totalStrikes > count) {
          vegaPE += (d.vegaPE || 0) / lotSizePE;
          gammaPE += (d.gammaPE || 0) / lotSizePE;
          thetaPE += (d.thetaPE || 0) / lotSizePE;
          deltaPE += (d.deltaPE || 0) / lotSizePE;
        }
      });

      return {
        volPE,
        oiPChgPE,
        oiChgPE,
        oiPE,
        volCE,
        oiPChgCE,
        oiChgCE,
        oiCE,
        strike: oiChgPE - oiChgCE,
        pcr: oiPE / oiCE,
        vegaCE,
        vegaPE,
        gammaCE,
        gammaPE,
        thetaCE,
        thetaPE,
        deltaCE,
        deltaPE,
      };
    }
  };



  const getMiddleStrike = (optionData, price) => {
    let lastIteratePrice = 0;
    let strike = {};

    for (let i = 0; i < optionData.length; i++) {
      if (price < optionData[i]?.strikePrice) {
        const middle =
          lastIteratePrice + (optionData[i].strikePrice - lastIteratePrice) / 2;
        if (middle > price) {
          strike = { index: i - 1, middleStrike: lastIteratePrice };
        } else {
          strike = { index: i + 1, middleStrike: optionData[i].strikePrice };
        }
        break;
      }
      lastIteratePrice = optionData[i]?.strikePrice;
    }
    return strike;
  };

  const getSymbolList = (optionData, index, selectStrikes) => {
    const start = 0;
    const end = optionData.length;

    let symbolList = [];
    let strikeList = new Set();
    let symbolsToStrikePrice = {};
    for (let i = start; i < end; i++) {
      symbolList.push(optionData[i]?.instrumentToken);

      const obj = symbolsToStrikePrice[optionData[i]?.strikePrice] || {};

      obj[optionData[i]?.instrumentType] = optionData[i]?.instrumentToken;
      obj['exchangeToken-' + optionData[i]?.instrumentType] = optionData[i]?.exchangeToken;
      obj['tradingSymbol-' + optionData[i]?.instrumentType] = optionData[i]?.tradingSymbol;
      obj['exchange-' + optionData[i]?.instrumentType] = optionData[i]?.exchange;
      obj['lotSize-' + optionData[i]?.instrumentType] = optionData[i]?.lotSize;
      obj['displayName-' + optionData[i]?.instrumentType] = optionData[i]?.displayName;
      obj['strike-' + optionData[i]?.instrumentType] = optionData[i]?.strikePrice;
      obj['tickSize-' + optionData[i]?.instrumentType] = optionData[i]?.tickSize;

      symbolsToStrikePrice[optionData[i]?.strikePrice] = obj;
      strikeList.add(optionData[i]?.strikePrice);
    }
    setSymbolsToStrike(symbolsToStrikePrice);

    return { symbolList, symbolsToStrikePrice, strikeList: [...strikeList] };
  };

  const insertColToCorrectPlace = (id, columnIds) => {
    let oldArray = [...columnIds];
    let newArray = [];

    // this array is always iterate with correct order
    config.positionedArray.forEach((col) => {
      if (oldArray.includes(col)) {
        newArray.push(col);
      } else {
        if (col === `${id}CE` || col === `${id}PE`) {
          newArray.push(col);
        }
      }
    });
    return newArray;
  };

  const saveSymbolData = (data, strike) => {
    stockDataRef.current[strike] = data;
    setSummary(getSummaryDataAtLoading(stockDataRef.current));
  };

  useEffect(() => {
    handleColumns();
  }, []);

  const handleColumns = () => {
    let newColIds = [...columnIds];
    moreColumnStatus.forEach((column, index) => {
      if (column.status) {
        let subColumnArray = config.combinedItems[column.id].arr;

        subColumnArray.forEach((subColumn) => {
          newColIds = insertColToCorrectPlace(subColumn, newColIds);
        });
      }

      if (moreColumnStatus.length === index + 1) setColumnIds(newColIds);
    });
  };


  const getStrike = (strikes) => {
    const filtered = Object.keys(tableData).reduce((acc, key) => {

      if (strikes.includes(key)) {
        acc[key] = tableData[key];
      }
      return acc;
    }, {});


  }


  return (
    <div
      className=" chartPageWrap opt-chn-tbl"
      style={{
        height,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        maxHeight: 'none',
      }}
    >
      {isLoder && <LoderCom />}
      <Card.Body style={{
        padding: "0.25rem 0",
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
      }}>

        <div style={{ flexShrink: 0 }}>
          <OptionChainTabs
            setSelectStrikes={(e) => { setSelectStrikes(e); setisLoder(true); }}
            setisQT={(e) => setisQT(e)}
            setOptType={(e) => setOptType(e)}
            setStraddle={(e) => setStraddle(e)}
            setisPosition={(e) => setisPosition(e)}
            isPosition={isPosition}
            selectStrikes={selectStrikes}
            isQT={isQT}
            optType={optType}
            type={type}
            isStraddle={isStraddle}
            atmVal={atmVal}
            setatmVal={setatmVal}
            hedge={hedge}
            sethedge={sethedge}
            hedgeVal={hedgeVal}
            sethedgeVal={sethedgeVal}
            isDeltaIV={isDeltaIV}
            setIsDeltaIV={setIsDeltaIV}
            setColumns={setColumns}
            columns={DropDonwcolumns}
            info={info}
            isSellFirst={isSellFirst}
            setisSellFirst={setisSellFirst}
            isSynFut={isSynFut}
            setisSynFut={setisSynFut}
          ></OptionChainTabs>
        </div>

        {type === "CustomOption" && middleStrike &&

          <CustomOption
            width={width}
            height={height}
            inputValues={inputValues}
            source={source}
            info={info}
            optionChainInstrumentsData={optionChainInstrumentsData}
            price={price}
            buySellClick={buySellClick}
            isQT={isQT}
            setisQT={setisQT}
            chartClick={chartClick}
            rowHover={rowHover}
            setColumns={setColumns}
            DropDonwcolumns={DropDonwcolumns}
            isSellFirst={isSellFirst}
            setisSellFirst={setisSellFirst}
          />
        }
        {selectInstrument && selectExpiry && type !== "CustomOption" &&
          <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            <OptionChainTable
              columns={columns()}
              columnIds={defCol}
              tableData={tableData}
              symbolsToStrike={symbolsToStrike}
              selectStrikes={selectStrikes}
              middleStrike={middleStrike}
              source={source}
              prevData={prevData}
              summary={summary}
              lotSizeEnabled={lotSizeEnabled}
              lotSizesByToken={lotSizesByToken}
              saveSymbolData={saveSymbolData}
              strikeArray={strikeArray}
              moreColumnStatus={moreColumnStatus}
              updateScroll={updateScroll}
              oicepeData={oicepeData}
              buySellClick={buySellClick}
              type={type}
              isStraddle={isStraddle}
              chartClick={chartClick}
              rowHover={rowHover}
              height={height}
              width={width}
              info={info}
              isPosition={isPosition}
            />
          </div>
        }
      </Card.Body>
      {null}
    </div>
  );
};

export default OptionActionTable;
